import { SITE } from '../data/fleet'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="wrap footer__grid">
        <div>
          <h3>Golden Mule Rentals</h3>
          <p>
            Dump, equipment, and utility trailers across the north
            {' '}{SITE.city} metro. Pick up free at our lot or have it
            delivered. Family run, cash bought, no fleet financing to pass
            along to you.
          </p>
        </div>

        <div>
          <h3>Contact</h3>
          <ul>
            <li><a href={SITE.phoneHref}>{SITE.phone}</a></li>
            <li>Dispatch 6 a.m. &ndash; 9 a.m., 7 p.m. &ndash; 9 p.m.</li>
          </ul>
        </div>

        <div>
          <h3>Site</h3>
          <ul>
            <li><a href="/#fleet">Fleet</a></li>
            <li><a href="/#rates">Rates and delivery</a></li>
            <li><a href="/#coverage">Delivery area</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="wrap footer__legal">
        <p>
          We rent equipment only. Loading, transport of material, and disposal
          are the renter&rsquo;s responsibility. We do not haul or dispose of
          waste, debris, or construction material.
        </p>
        <p style={{ marginTop: '0.5rem' }}>
          &copy; {year} Golden Mule Rentals. Dallas&ndash;Fort Worth, Texas.
        </p>
      </div>
    </footer>
  )
}
